import script from "./ScrollTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollTable.vue?vue&type=script&setup=true&lang=js"

import "./ScrollTable.vue?vue&type=style&index=0&id=6189f1c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6189f1c6"]])

export default __exports__